import { FC, useEffect, useState } from 'react'
import { useLazyQuery } from '@apollo/client'
import { useAppSelector } from 'hooks/store'

import {
  GET_DOCUMENT_CHECKLIST_GAPS,
  GetDocumentChecklistGapsQueryResponse
} from 'share/queries/documents'
import { DocumentGapDate } from 'share/domain/document'

import GoBackHeader from 'components/organisms/GoBackHeader'
import { loadingSpinnerPortal } from 'components/atoms/LoadingSpinner'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import './styles.scss'

const AiDocumentsSubmissionSummary: FC = () => {
  const activeCase = useAppSelector((state) => state.activeCase)
  const documentProcessing = useAppSelector((state) => state.documentProcessing)
  const [groupHeaderName, setGroupHeaderName] = useState('')
  const [documentGaps, setDocumentGaps] = useState<DocumentGapDate[]>([])
  const [goBackHeaderText, setGoBackHeaderText] = useState('Submission Summary')

  const [getDocGaps, { loading, data, error }] =
    useLazyQuery<GetDocumentChecklistGapsQueryResponse>(
      GET_DOCUMENT_CHECKLIST_GAPS,
      {
        fetchPolicy: 'network-only'
      }
    )

  useEffect(() => {
    if (activeCase && documentProcessing) {
      if (activeCase.matter) {
        if (activeCase.matter.id) {
          getDocGaps({
            variables: {
              request: {
                caseId: activeCase.matter.id,
                documentCheckListItemId:
                  documentProcessing?.selectedDocumentChecklistItemId || 0
              }
            }
          })
        }
      }
    }
  }, [activeCase, documentProcessing])

  useEffect(() => {
    if (
      data &&
      data?.documents.documentChecklistDocumentGaps?.documentChecklistItemDates
        .length > 0
    ) {
      setDocumentGaps(
        data.documents.documentChecklistDocumentGaps.documentChecklistItemDates
      )
    }

    if (
      data &&
      data?.documents.documentChecklistDocumentGaps?.groupHeaderName
    ) {
      setGroupHeaderName(
        data?.documents.documentChecklistDocumentGaps?.groupHeaderName
      )
    }

    if (data && documentProcessing?.selectedDocumentChecklistItem?.name) {
      setGoBackHeaderText(
        `${documentProcessing?.selectedDocumentChecklistItem?.name} Submission Summary`
      )
    }
  }, [data])

  if (error) {
    return <div>{error?.message}</div>
  }

  const rowClass = (rowData: DocumentGapDate) => {
    if (rowData.message === 'Missing') {
      return 'row-missing'
    } else {
      return ''
    }
  }

  const nameGroupTemplate = (rowData: DocumentGapDate) => {
    return (
      <>
        <div>{rowData.name}</div>
        <div>{rowData.group}</div>
      </>
    )
  }

  const startEndPeriodTemplate = (rowData: DocumentGapDate) => {
    return (
      <>
        <div>{rowData.startDate}</div>
        <div>{rowData.endDate}</div>
      </>
    )
  }

  return (
    <>
      {loading && loadingSpinnerPortal()}
      <GoBackHeader text={goBackHeaderText} />
      <div className='mt-5'></div>
      <div className='card'>
        <DataTable
          value={documentGaps}
          stripedRows
          tableStyle={{ minWidth: '5rem' }}
          rowClassName={rowClass}
          className='black-header-summary'
        >
          <Column
            field='name'
            body={nameGroupTemplate}
            header={
              <>
                <div style={{ textAlign: 'left' }}>Debtor Name</div>
                <div style={{ textAlign: 'left' }}>{groupHeaderName}</div>
              </>
            }
          ></Column>
          <Column
            field='startDate'
            body={startEndPeriodTemplate}
            header={
              <>
                <div style={{ textAlign: 'left' }}>Period Start</div>
                <div style={{ textAlign: 'left' }}>Period End</div>
              </>
            }
          ></Column>
          <Column field='message' header='Status'></Column>
        </DataTable>
      </div>
    </>
  )
}

export default AiDocumentsSubmissionSummary
